/***
 *
 *   LANDING INTAKE
 *   The public per-project request form (see /project/:name), sold.
 *
 **********/

import { Icon, useTheme } from 'components/lib';
import { useTranslate } from 'app/translations';
import Shared from './landing.tailwind.js';
import Style from './intake.tailwind.js';

const POINTS = ['categories', 'allowlist', 'shareable'];

/* The public request form at /project/:name. Captured without browser chrome —
   the Style.url bar in the frame stands in for it. */
const SHOT = {
    light: '/assets/screenshots/valetify-form_light.png',
    dark: '/assets/screenshots/valetify-form_dark.png',
    width: 733,
    height: 594,
};

export function LandingIntake(props) {
    const { _t } = useTranslate();
    const { isDark } = useTheme();

    return (
        <section id="intake" className={Shared.sectionSurface}>
            <div className={`${Shared.container} ${Shared.split} items-center`}>
                <div>
                    <div className={Shared.eyebrow}>{_t('landing.intake.eyebrow')}</div>
                    <h2 className={Shared.title}>{_t('landing.intake.title')}</h2>
                    <p className={Style.lede}>{_t('landing.intake.lede')}</p>

                    <ul className={Style.list}>
                        {POINTS.map((point) => (
                            <li key={point} className={Style.item}>
                                <Icon
                                    image="check"
                                    size={14}
                                    color="hsl(var(--primary-600))"
                                    className={Style.check}
                                />
                                {_t(`landing.intake.points.${point}`)}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className={Style.frame}>
                    <div className={Style.url}>{_t('landing.intake.url')}</div>

                    {/* Theme-matched variant, same approach as the hero. */}
                    <img
                        src={isDark ? SHOT.dark : SHOT.light}
                        alt={_t('landing.intake.shot.alt')}
                        width={SHOT.width}
                        height={SHOT.height}
                        className={Style.screen}
                    />
                </div>
            </div>
        </section>
    );
}
